<template>
  <div class="home-sections">
    <component
      :is="getComponentType(section)"
      v-for="(section, k) in sections"
      :key="'home_component_' + k"
      :section="section"
    ></component>
  </div>
</template>

<script>
import SectionImageText from './HomeSectionImageText'
import SectionCollection from './HomeSectionCollection'

export default {
  props: {
    sections: {
      type: Array,
    },
  },
  methods: {
    getComponentType(v) {
      if (v.type == 'text_image') return 'SectionImageText'

      if (v.type == 'collection') return 'SectionCollection'

      return false
    },
  },
  components: {
    SectionImageText,
    SectionCollection,
  },
}
</script>

<style lang="scss">
@import '~/styles/base.scss';

.home-sections {
  display: grid;
  grid-row-gap: 150px;
  @include cx-home-s();
  margin-bottom: 300px;
}
</style>